import ObjectId from 'bson-objectid'

export default function generateId() {
  return new ObjectId().toString()
}
